import React, { useEffect, useState } from 'react'
import { Button, Col, Image, Row } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { bucket_url } from '../../constants/const';
import PdfModal from '../pdfModal/pdfModal';

import DummyPdf from '../../assets/images/dummy/DummyMultiPdf.pdf';

const PublicationImageCarousel = (props) => {
    const { publication } = props;
    const [ selectedImage, setSelectedImage ] = useState(null)
    const [ visibleReader, setVisibleReader ] = useState(false)
    const [ selectedPDF, setSelectedPDF ] = useState(null)


    useEffect(() => {
        if (!!publication) {
            setSelectedImage(publication.images[0])
        }
    }, [publication])

    const changeImage = (image) => {
        setSelectedImage(image);
    }

    const closeReader = () => {
        setSelectedPDF(null);
        setVisibleReader(false);
    }

    const openReader = (pdf) => {
        setSelectedPDF(pdf);
        setVisibleReader(true);
    }

    return (
        <>
            { (!!visibleReader && !!selectedPDF) && <PdfModal publication={publication} pdf={selectedPDF} visible={visibleReader} closeModal={closeReader.bind(this)} /> }
            <div className="publication-carousal-wrap mt-0 mt-lg-4">
                <Row>
                    <Col xs={12} md={{ order: 1, span: 9 }} className="mb-3 mb-md-0">
                        <div className="d-flex flex-column align-items-center">
                            <Image className='img-fluid w-100' src={`${bucket_url}${selectedImage}`} />
                            {
                                !!publication.pdfUrl &&
                                <LinkContainer to={'#'} className="mt-5 d-none d-md-block">
                                    <Button className='publication-read-more text-center' variant="outline-danger" onClick={() => openReader(publication.pdfUrl)}>পড়ে দেখুন</Button>
                                </LinkContainer>
                            }
                        </div>
                    </Col>
                    <Col xs={12} md={{ order: 0, span: 3 }}>
                        <Row>
                            {
                                !!publication &&
                                publication.images.map((image, index) => (
                                    (index < 3) &&
                                    <Col xs={4} md={12} className="mb-0 mb-md-3" key={index}>
                                        <div className={`publication-image-carousel-item-wrap ${image === selectedImage && 'active'}`} onClick={() => changeImage(image)}>
                                            <img className='d-block img-fluid w-100' src={`${bucket_url}${image}`} alt={`Cover ${index}`} />
                                        </div>
                                    </Col>
                                ))
                            }
                        </Row>
                        {/* <div className="d-felx flex-column">
                        </div> */}
                        {
                            !!publication.pdfUrl &&
                            <LinkContainer to={'#'} className="mt-5 d-block d-md-none">
                                <Button className='publication-read-more text-center' variant="outline-danger" onClick={() => openReader(publication.pdfUrl)}>পড়ে দেখুন</Button>
                            </LinkContainer>
                        }
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default PublicationImageCarousel